export default __webpack_public_path__ + "static/media/SSC_2017_FluView.3b08accf.pdf";